import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@core/service/auth.service';
import { MenuService } from '@components/menu/menu.service';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule, RouterLink, MatButtonModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    isAuthenticated: boolean = false;

    constructor(
        private drawer: MenuService,
        private readonly authService: AuthService,
        private readonly router: Router
    ) {
        if (this.authService.isAuthenticated()) {
            this.isAuthenticated = true;
        }

    }

    ngOnInit() {
        this.authService.userProfile.subscribe((data: any) => {
            this.isAuthenticated = data?.accessToken ? true : false;
        })
    }

    signOut() {
        this.authService.logout();
        this.router.navigate(['/login-clerk']);
    }

    openDrawer() {
        this.drawer.open();
    }

    clearStorage() {
        this.authService.logout();
        localStorage.clear();
        this.isAuthenticated = false;
        void this.router.navigate(['/direction'])
    }
}
